<template>
    <div class="ti">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="中行支付" name="first">
          <div class="zhohang">
            <el-form label-width="100px">
                <el-form-item label="appid">
                  <el-input placeholder="appid" v-model="pay.appid" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="商户号">
                  <el-input v-model="pay.merchantNo" placeholder="请输入商户号"></el-input>
                </el-form-item>
                <el-form-item label="商户密码">
                  <el-input placeholder="请输入密码" v-model="pay.pwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="上传pfx文件">
                  <el-upload
                      class="upload-demo"
                      :action="url"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :on-success="handleAvatarSuccess"
                      accept=".pfx"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :before-upload="beforeAvatarUpload">
                      <el-button size="small" type="primary" class="texts">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传.pfx文件，且不超过3M<span v-if="pay.pfx">，（已上传）</span></div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="上传cer文件">
                  <el-upload
                      class="upload-demo"
                      :action="url"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :on-success="handleAvatarSuccess1"
                      accept=".cer"
                      multiple
                      :limit="1"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :before-upload="beforeAvatarUpload">
                      <el-button size="small" type="primary" class="texts">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传.cer文件，且不超过3M<span v-if="pay.cer">，（已上传）</span></div>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="texts" @click="onSubmit">立即保存</el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="微信支付" name="second">
          <div class="zhohang">
            <el-form label-width="120px">
              <!-- 特约商户 -->
                <el-form-item label="APPID">
                  <el-input placeholder="appid" v-model="wxPay.sub_appid" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="微信支付商户号">
                  <el-input v-model="wxPay.sub_mch_id" placeholder="请输入商户号"></el-input>
                </el-form-item>
                 <el-form-item label="微信支付api密匙">
                  <el-input placeholder="请输入api密匙" v-model="wxPay.sub_api" show-password></el-input>
                </el-form-item>
                <el-form-item label="微信支付cert">
                  <el-input type="textarea" rows="5" v-model="wxPay.sub_cert"></el-input>
                </el-form-item>
                <el-form-item label="微信支付key">
                  <el-input type="textarea" rows="5" v-model="wxPay.sub_key"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="texts" @click="onSubmitWx">立即保存</el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
     activeName: 'first',
     id:'',
     url:'',
     pay:{
         appid:'',
         merchantNo:'',
         pwd:'',
         pfx:'',
         cer:'',
         type:"zh",
         state:1,
     },
     wxPay:{
         sub_appid:'',
         sub_mch_id:'',
         sub_api:'',
         sub_cert:'',
         sub_key:'',
     },
     fileList:[],
    }
  },
  //界面没出来前加载
  created() {
    
  },
  // 加载数据
  mounted(){
    this.url = this.$myhttp.defaults.baseURL + "/admin/payposts";
    this.id = this.$route.query.id;
    this.pay.appid = this.$route.query.appid;
    this.wxPay.sub_appid = this.$route.query.appid;
    this.$myhttp.get('admin/getPay?type=zh&appid='+this.pay.appid,{
    'Content-Type': 'application/json'
    }).then(backdata=>{ // 异步执行成功后
        var data =  backdata.data;
        if(data.list.length > 0){
          this.pay = data.list[0];
        }
        if(data.wxPay.length > 0){
          this.wxPay = data.wxPay[0];
        }
        // console.log(data)
        // 
    });
  },
  //事件
  methods: {
    handleClick(tab, event) {
        // console.log(tab, event);
    },

    //文件上传
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //限制大小
    beforeAvatarUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 3;
      if (!isLt7M) {
        this.$message.error('上传文件大小不能超过 3MB!');
      }
      return isLt7M;
    },
    //上传成功pfx
    handleAvatarSuccess(res, file){
      this.pay.pfx = file.response;
    },
    //上传成功cer
    handleAvatarSuccess1(res, file){
      this.pay.cer = file.response;
    },
    //保存中国银行信息
    onSubmit(){
      // console.log(this.pay);
      this.loading=true;
      this.$myhttp.post('admin/payAdd',this.pay,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.loading=false;
            this.$Message.success('提交成功!');
      });
    },
    //保存微信支付（特约商户）
    onSubmitWx(){
      // console.log(this.wxPay);
      this.loading=true;
      this.$myhttp.post('admin/wxPayAdd',this.wxPay,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.loading=false;
            this.$Message.success('提交成功!');
      });
    }

  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path == "/Applets/appletsPay"){
        // this.id = this.$route.query.id;
        // this.pay.appid = this.$route.query.appid;
        // console.log(this.pay.appid )
        var appid = this.$route.query.appid;
        this.$myhttp.get('admin/getPay?type=zh&appid='+appid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
            var data =  backdata.data;
            if(data.list.length > 0){
              this.pay = data.list[0];
            }else{
              this.pay={
                appid:appid,
                merchantNo:'',
                pwd:'',
                pfx:'',
                cer:'',
                type:"zh",
                state:1,
              };
            }
            if(data.wxPay.length > 0){
              this.wxPay = data.wxPay[0];
            }else{
              this.wxPay={
                sub_appid:appid,
                sub_mch_id:'',
                sub_api:'',
                sub_cert:'',
                sub_key:'',
              };
            }
            
        });
      }
    }
  },
}
</script>
<style scoped>
.ti{
    margin: 10px;
    width: 98%;
}
.zhohang{
  width: 50%;
}
.texts{
    color: rgb(240, 236, 236);
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Applets/appletsPay.vue